import "./index.scss";

import { Link, Outlet } from "react-router-dom";
import Brand from "../../components/Brand";

export default function Auth() {
    return (
        <div className="__auth">
            <div className='root'>
                <div className='aside'>
                    <div className='aside__content'>
                        <Link to="/" className="aside__brand-link">
                            <Brand.Condensed className='aside__brand-logo' />
                        </Link>
                        <p className='aside__title'>
                            Welcome Back
                        </p>
                        <p className='aside__subtitle'>
                            Join a user base of <br /> thousands of users
                        </p>
                    </div>
                </div>
                <div className='container'>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}